import { gql } from 'graphql-request'
import { Route, Routes, Navigate } from 'react-router-dom'
import {
  ShieldCheck,
  UserSquare2,
  Mail,
  CreditCard,
  ArrowLeftRight,
  UserCircle
} from 'lucide-react'

import { useQuery } from '@hooks/graphql'
import Breadcrumbs from '@components/Breadcrumbs'
import VerticalNavTabs from '@components/VerticalNavTabs'

import Account from './Account'
import Profile from './Profile'
import EmailPreferences from './EmailPreferences'
import SecuritySettings from './SecuritySettings'
import Billing from './Billing'
import Integrations from './Integrations'
import Spinner from '../../../components/Spinner'

const ME_QUERY = gql`
  query me {
    me {
      profile {
        firstName
        lastName
        biography
        googleClassroomIntegrationEnabled
        microsoftTeamsIntegrationEnabled
        subscribedToEmailMarketing
        allowSupportAccess
        profileImage {
          url
        }
      }
    }
  }
`

const Settings = () => {
  const { isLoading, refetch, data: { me: { profile = {} } = {} } = {} } = useQuery({
    queryKey: ['settings'],
    gqlQuery: ME_QUERY
  })

  return (
    <>
      <Breadcrumbs>
        <Breadcrumbs.Text label='Settings' />
      </Breadcrumbs>

      <div className='flex flex-row h-[calc(100vh-64px)]'>
        <VerticalNavTabs>
          <VerticalNavTabs.Link to='account' label='Account' icon={<UserCircle size={16} />} />
          <VerticalNavTabs.Link to='profile' label='Profile' icon={<UserSquare2 size={16} />} />
          <VerticalNavTabs.Link to='security' label='Security settings' icon={<ShieldCheck size={16} />} />
          <VerticalNavTabs.Link to='email' label='Email preferences' icon={<Mail size={16} />} />
          <VerticalNavTabs.Link to='integrations' label='Integrations' icon={<ArrowLeftRight size={16} />} />
          <VerticalNavTabs.Link to='billing' label='Billing' icon={<CreditCard size={16} />} />
        </VerticalNavTabs>

        <div className='grow p-5'>
          <Choose>
            <When condition={isLoading}>
              <Spinner className='relative top-0 left-0 flex items-center justify-center w-full h-full' />
            </When>

            <Otherwise>
              <Routes>
                <Route path='/' element={<Navigate to='account' />} />
                <Route path='account' element={<Account />} />
                <Route
                  path='profile'
                  element={
                    <Profile
                      firstName={profile.firstName}
                      lastName={profile.lastName}
                      biography={profile.biography}
                      profileImageUrl={profile.profileImage?.url}
                      refetch={refetch}
                    />
                  }
                />
                <Route
                  path='security'
                  element={
                    <SecuritySettings
                      allowSupportAccess={profile.allowSupportAccess}
                      refetch={refetch}
                    />
                  }
                />
                <Route
                  path='email'
                  element={
                    <EmailPreferences
                      subscribedToEmailMarketing={profile.subscribedToEmailMarketing}
                      refetch={refetch}
                    />
                  }
                />
                <Route
                  path='integrations'
                  element={
                    <Integrations
                      googleClassroomIntegrationEnabled={profile.googleClassroomIntegrationEnabled}
                      microsoftTeamsIntegrationEnabled={profile.microsoftTeamsIntegrationEnabled}
                      refetch={refetch}
                    />
                  }
                />
                <Route path='billing' element={<Billing />} />
              </Routes>
            </Otherwise>
          </Choose>
        </div>
      </div>
    </>
  )
}

export default Settings
